// import storage from './storage';
import { MESSAGE_WIDGET_TRACK_VIEW, MESSAGE_WIDGET_TRACK_CLICK } from './constant';
import {
  checkIsAdmin,
  checkIsVisibleBrowserTab,
  checkIsMobile,
  getCookie,
  setCookie,
  isValidPage
} from '../helpers/utils';
import ajax from '../helpers/ajax';

class PopupReview {
  constructor() {
    this.fakeLimit = 100; // Max reviews length to call fakeFetch()
    this.shownReviews = 0; // count displayed reviews
    this.numOfLoop = 0;
    this.config = {}; // store configs like timming, limit, ...
    this.reviews = []; // current reviews list
    this.review = null; // current review to show
    this.prevReviews = []; // previous reviews list
    // global variables belows
    this.pageType = typeof alireviews_page_type != 'undefined' ? alireviews_page_type : null; // index, product, collection, cart...
    this.collectionId = typeof alireviews_collection_id != 'undefined' ? alireviews_collection_id : null;
    this.productId = typeof alireviews_product_id != 'undefined' ? alireviews_product_id : null;
    this.customerId = typeof alireviews_customer_id != 'undefined' ? alireviews_customer_id : null;
    this.tag = typeof alireviews_tags != 'undefined' ? alireviews_tags : null;
    this.lastPurchase = typeof alireviews_last_purchase != 'undefined' ? alireviews_last_purchase : null;
    this.avgOrder = typeof alireviews_avg_order_value != 'undefined' ? alireviews_avg_order_value : null;
    this.totalSpent = typeof alireviews_total_order_values != 'undefined' ? alireviews_total_order_values : null;
    this.listProductIdInCart = typeof alireviews_product_in_cart != 'undefined' ? alireviews_product_in_cart : null;

    /**
     * POST params of fetch list reviews API
     * @type {Object}
     */
    this.params = {
      shop_name: window.Shopify.shop,
      theme_id: window.Shopify.theme.id,
      page: this.pageType,
      product_id: this.productId,
      product_in_cart: this.listProductIdInCart,
      collection_id: this.collectionId,
      is_admin: checkIsAdmin(),
      device: checkIsMobile() ? 'mobile' : 'desktop',
      customer_id: this.customerId,
      tag: this.tag,
      last_purchase: this.lastPurchase,
      avg_order: this.avgOrder,
      total_spent: this.totalSpent,
      prev_review_ids: null,
    };
  }

  fire() {
    if (! isValidPage(this.pageType)) {
      return;
    }
    this.getCountryCode();
    this.fetch();
  }

  async fetch(isFirstTime = true) {
    // TODO should fetch reviews before the reviews list empty
    // to avoid time delay

    // Stop fetch reviews, and loop
    if (
      !isFirstTime
      && this.isReachLimit()
    ) {
      this.loop();
      return;
    }

    // [Cheat] to reduce call API
    if (!isFirstTime && this.prevReviews.length >= this.fakeLimit) {
      this.fakeFetch();
      return;
    }

    if (!isFirstTime) {
      this.params.prev_review_ids = this.prevReviews.map(({ comment_id }) => comment_id).join(',');
    }

    const res = await ajax.post('/v1/review-pops/list', this.params);

    if (res.status == false || !res.data.reviews.length) return;

    isFirstTime && (this.numOfLoop = res.data.interaction.loop);
    this.config = this.parseConfig(res.data);

    setTimeout(() => {
      // random reviews
      this.reviews = res.data.reviews.sort(() => Math.random() - 0.5);
      this.review = this.reviews[0];

      // store to previous reviews
      this.prevReviews = this.prevReviews.concat(this.reviews);

      this.show();
    }, isFirstTime ? this.config.delay : this.config.timeBetween);

    // Store country_code to cookie
    if (
      res.data.extra && res.data.extra.country_code
      && !getCookie('ar_country_code')
    ) {
      setCookie('ar_country_code', res.data.extra.country_code, 365); // expires 365 days
      this.params.country_code = res.data.extra.country_code;
    }

    // set is_transcy_connected
    if (res.data.extra) {
      this.params.is_transcy_connected = res.data.extra.is_transcy_connected;
    }
  }

  fakeFetch() {
    this.reviews = this.prevReviews.map(item => ({ ...item }));
    this.reviews = this.reviews.sort(() => Math.random() - 0.5);
    this.review = this.reviews[0];

    setTimeout(() => {
      this.show();
    }, this.config.timeBetween);
  }

  parseConfig(response) {
    // TODO diff old with new config to refresh counter
    // num_of_pops => max popups per session
    // num_of_pops = -1 => unlimited
    let limit = response.interaction.num_of_pops;
    let totalReviews = response.reviews.length;

    if (
      (limit != -1 && totalReviews < limit)
      || (limit == -1 && totalReviews < 10) // NUM_POPUP_DEFAULT_LIMIT=10 in ListReviewPopService.php
    ) {
      limit = totalReviews;
    }

    return {
      delay: response.interaction.first_show_time,
      duration: response.interaction.life_time,
      timeBetween: Array.isArray(response.interaction.between_time)
        ? Math.floor(Math.random() * response.interaction.between_time[1]) + response.interaction.between_time[0]
        : response.interaction.between_time,
      limit: limit,
    };
  }

  getCountryCode() {
    const countryCode = getCookie('ar_country_code');

    if (countryCode) {
      this.params.country_code = countryCode;
      return;
    }
  }

  show() {
    if (this.isReachLimit()) {
      this.loop();
      return;
    }

    let interval = setInterval(() => {
      if (checkIsVisibleBrowserTab() === false) return;

      clearInterval(interval);
      let elBody = document.body;
      elBody && elBody.insertAdjacentHTML('beforeend', this.review.template);
      // $('body').append(this.review.template);
      // this.checkIntegrateTranscy();
      // $('.alr-rating').length && $('.alr-rating').rating();
      setTimeout(() => {
        // $('.ar-popup-reviews').addClass('mfp-ready');
        let elArPopupReviews = document.querySelector(".ar-popup-reviews");
        elArPopupReviews && elArPopupReviews.classList.add("mfp-ready");
      }, 500);

      this.shownReviews++;

      let timeout = setTimeout(() => {
        this.showNext();
      }, this.config.duration);

      let elArBtnClickPopupClose = document.querySelector(".ar-btn-click-popup-close");
      elArBtnClickPopupClose && elArBtnClickPopupClose.addEventListener("click", () => {
        clearTimeout(timeout);
        this.close();
      });

      let elArBtnShowModalReviews = document.querySelector(".ar-btn-show-modal-reviews")
      elArBtnShowModalReviews && elArBtnShowModalReviews.addEventListener("click", () => {
        clearTimeout(timeout);
        this.close();

        window.postMessage({
          openModalDetailReview: true,
          dataDetailReview: {
            shop_id: this.review.shop_id,
            comment_id: this.review.comment_id,
            product_id: this.review.product_id,
            widgetId: this.review.widget_id,
            type_page: this.pageType,
            is_show_reply: "",
            source: "popup",
          }
        });

        window.postMessage({
          message: MESSAGE_WIDGET_TRACK_CLICK,
          data: {
            shopId: this.review.shop_id,
            widgetId: this.review.widget_id,
            productId: this.review.product_id
          }
        });
      });

      window.postMessage({
        message: MESSAGE_WIDGET_TRACK_VIEW,
        data: {
          shopId: this.review.shop_id,
          widgetId: this.review.widget_id,
        }
      });
    }, 1000);
  }

  checkIntegrateTranscy() {
    if(!this.params.is_transcy_connected){
      let elPopupReviews =  document.querySelector('.ar-ctn-popup-reviews')
      if(elPopupReviews){
        elPopupReviews.classList.add('notranslate')
      }
    }
  }

  showNext() {
    let elArPopupReviewsWrap = document.querySelector(".ar-popup-reviews-wrap");
    if (elArPopupReviewsWrap && elArPopupReviewsWrap.matches(':hover')) {
      setTimeout(() => {
        this.showNext();
      }, 1000);
      return;
    }
    this.close();

    // Get next review
    let nextItem;
    let index = this.reviews.indexOf(this.review);
    if (index >= 0 && index < this.reviews.length - 1) {
      nextItem = this.reviews[index + 1];
    }

    // Continue fetch reviews
    if (typeof nextItem === 'undefined') {
      this.fetch(false);
      return;
    }

    this.review = nextItem;

    setTimeout(() => {
      this.show();
    }, this.config.timeBetween);
  }

  close() {
    let elArCtnPopupReviews = document.querySelector(".ar-ctn-popup-reviews");
    if (!elArCtnPopupReviews) return;
    let elArPopupReviews = document.querySelector(".ar-popup-reviews");
    elArPopupReviews && elArPopupReviews.classList.remove("mfp-ready");
    elArPopupReviews && elArPopupReviews.classList.add("mfp-removing");
    // $('.ar-popup-reviews').removeClass('mfp-ready');
    // $('.ar-popup-reviews').addClass('mfp-removing');
    setTimeout(() => {
      elArCtnPopupReviews && elArCtnPopupReviews.remove();
    }, 500);
  }

  loop() {
    if (this.numOfLoop < 1) {
      return;
    }

    this.numOfLoop--;

    // Reset counter
    this.shownReviews = 0;

    // Clone shown reviews list
    this.reviews = this.prevReviews.map(item => ({ ...item }));
    this.review = this.reviews[0];

    // Then, show
    setTimeout(() => {
      this.show();
    }, this.config.timeBetween);

    return;
  }

  isReachLimit() {
    return this.config.limit != -1 && this.shownReviews >= this.config.limit;
  }
}

const popupReview = new PopupReview();

window.addEventListener('load', function () {
  popupReview.fire();
})

window.addEventListener('message', (event) => {
  if (event.data.hasOwnProperty('openModalDetailReview')) {
    if (event.data.openModalDetailReview === false) {
      // $('body').removeClass('popup-reviews-modal-open');
      let elBody = document.body;
      elBody && elBody.classList.remove("popup-reviews-modal-open");
      popupReview.showNext();
    }
  }
});

